module.exports = __webpack_public_path__ + "img/xiamenywc_logo.56910b2f.png";